export default __webpack_public_path__ + "static/media/Group 10685.5fae32a8.svg";